import React from 'react'
import {Link } from "react-router-dom";
import { FaLinkedin } from "react-icons/fa6";
import { FaGithubSquare } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { FaSquareInstagram } from "react-icons/fa6";
import { FaFacebookSquare } from "react-icons/fa";


export default function Footer() {

  const isMd = window.innerWidth >= 768;
  
  return (
    <div className='flex w-full h-[25vh] md:h-[30vw] justify-center items-center ' >
      <div className='relative flex flex-col h-[90%] w-[90%] overflow-hidden justify-end items-center bg-gradient-to-tr from-[#341D42] to-[#141414] rounded-[20px] shadow-[0_8px_25px_rgba(0,0,0,0.50)]'>
        <div className="absolute
             w-[600px] h-[600px]
             right-[-100px] top-[-20px]
             rounded-full border-4
             border-cyan-400/40 "></div>
        <div className='flex flex-row justify-between h-[75%] w-[90%]'>
          <div className='flex flex-col flex-[2]'>
            <p className='text-[#f2f2f2] text-xl md:text-5xl font-bold'>You scrolled this far!</p>
            <p className='text-[#f2f2f2] text-sm md:text-2xl leading-tight md:leading-loose'>We should probably connect.</p>
            <div className='flex flex-row mt-2 md:mt-6 gap-2 md:gap-4'>
              <Link to={"https://www.linkedin.com/in/sudip4262/"} target='_blank'><FaLinkedin size={isMd? 70 : 35} color='#FFF' className="hover:scale-[1.1] transition-all ease-in-out duration-200"/></Link>
              <Link to={"https://github.com/Sudip4262"} target='_blank'><FaGithubSquare size={isMd? 70 : 35} color='#FFF' className="hover:scale-[1.1] transition-all ease-in-out duration-200"/></Link>
              <Link to={"https://www.instagram.com/_finding_errors?igsi=Ymh1ZzYzN3dtYXBz&utm_source=qr"} target='_blank'><FaSquareInstagram size={isMd? 70 : 35} color='#FFF' className="hover:scale-[1.1] transition-all ease-in-out duration-200"/></Link>
            </div>
          </div>
          <div className='flex z-50 flex-[1] items-end'>
            <Link to={"/"}>
            <img
              src={`${process.env.PUBLIC_URL}/photos/Logo.png`}
              alt="Sudip"
              className='w-full mb-6'
            />
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
